import { render, staticRenderFns } from "./SignatureIncidenceStatusDoc.vue?vue&type=template&id=5c80a803"
import script from "./SignatureIncidenceStatusDoc.vue?vue&type=script&lang=js"
export * from "./SignatureIncidenceStatusDoc.vue?vue&type=script&lang=js"
import style0 from "./SignatureIncidenceStatusDoc.vue?vue&type=style&index=0&id=5c80a803&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports